// 🔧 social_generator.js
// ✅ Purpose: Generates realistic social media links for LGV Seed Engine entities
// ✅ Features:
// - Creates placeholder Facebook and Instagram profiles
// - Can be reused by entries, owners, sponsors, vendors, and volunteers
// - Keeps social generation separate from other generators
// - Future-ready for AI-generated and customer-provided social accounts
// - Fully block-commented for clarity and future devs

const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "")
    .slice(0, 24);

export const generateSocialLinks = ({
  seed = "",
} = {}) => {
  const slug = slugify(seed || "demo");

  return [
    {
      platform: "Instagram",
      label: "Instagram",
      url: `https://instagram.com/${slug}`,
    },

    {
      platform: "Facebook",
      label: "Facebook",
      url: `https://facebook.com/${slug}`,
    },
  ];
};